import { Modal, message } from "antd";
import { callApi } from "../../wea-tools/callApi";
import WindowFunc from "../../wea-tools/window";
import WeaLocaleProvider from "../../wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;

export const defaultIcon = {
  "Mr.": "/images/messageimages/temp/man_wev8.png",
  "Ms.": "/images/messageimages/temp/women_wev8.png"
};

export const utf16To8 = str => {
  const len = str.length;
  let out = "";
  for (let i = 0; i < len; i++) {
    const c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007f) {
      out += str.charAt(i);
    } else if (c > 0x07ff) {
      out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
      out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    } else {
      out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
      out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
    }
  }
  return out;
};

export const createQRCode = userinfo => {
  const txt =
    `BEGIN:VCARD \nVERSION:3.0 \nN:${userinfo.lastname} \n` +
    `TEL;CELL;VOICE:${userinfo.mobile} \n` +
    `TEL;WORK;VOICE:${userinfo.telephone} \n` +
    `EMAIL:${userinfo.email} \n` +
    `TITLE:${userinfo.jobtitleName} \n` +
    `ROLE:${userinfo.departmentName} \n` +
    `ADR;WORK:${userinfo.locationName} \nEND:VCARD`;
  return utf16To8(txt);
};

/**
 * 调用e-message发起会话
 * (em6)
 * @param conventioners  参与会话人员，群，（多个用逗号分隔）
 * @param openType 会话创建类型 0：单聊   1：群聊（一般用不到）  2：创建新的群聊
 * @param groupName 群聊名称
 * @param extra 可选,消息体中内容 extra中的msgType 要推送的消息类型，1表示RC:TxtMsg 文本消息，2表示 RC:ImgMsg图片消息  6表示分享类型消息 FW:CustomShareMsg
 *
 * em7接口说明： http://192.168.1.241:8076/web/#/1?page_id=256
 */

export function sendMsgToPC(
  conventioners,
  openType,
  groupName,
  extra,
  successCallBack,
  errorCallBack
) {
  if (window.emJoinStatus.joinStatus && window.emJoinStatus.emSwitch === "1") {
    // em7
    openEM7(
      conventioners,
      openType,
      groupName,
      extra,
      successCallBack,
      errorCallBack
    );
  } else {
    // em6
    openEM6(
      conventioners,
      openType,
      groupName,
      extra,
      successCallBack,
      errorCallBack
    );
  }
}

const openEM6 = (
  conventioners,
  openType,
  groupName,
  extra,
  successCallBack,
  errorCallBack
) => {
  $.ajax({
    url: "/social/im/SocialIMOperation.jsp?operation=openPCconversation",
    data: {
      conventioners,
      openType,
      groupName,
      extra
    },
    type: "post",
    dataType: "json",
    contentType: "application/x-www-form-urlencoded; charset=utf-8",
    success(data) {
      if (data != null) {
        if (data.pcStatus == 0 && data.webStatus == 0) {
          // pc和web都不在
          Modal.warning({
            title: getLabel("15172", "系统提示"),
            content: getLabel(
              "386482",
              "检查到您的web端和客户端的e-message不在线，请打开任意一端进行会话！"
            )
          });
        } else if (data.webStatus == 1) {
          // web在线
          if (WindowFunc.getTop().$("#socialIMFrm").length > 0) {
          } else {
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
              message.error(
                getLabel(
                  "520784",
                  "您发起的e-message聊天已经建立，请到主页进行消息发送！"
                )
              );
            }
          }
        } else {
          // pc在线不作判断
        }
        typeof successCallBack === "function" && successCallBack(data);
      } else {
        message.error(getLable("386484,", "对话创建失败！"));
        typeof errorCallBack === "function" && errorCallBack();
      }
    },
    error(XMLHttpRequest, textStatus, errorThrown) {
      message.error(getLable("386485", "请求发送失败，请您检查当前网络！"));
      typeof errorCallBack === "function" && errorCallBack();
    }
  });
};

const openEM7 = (
  conventioners,
  openType,
  groupName,
  extra,
  successCallBack,
  errorCallBack
) => {
  let datas = {};
  if (openType == "0") {
    // 单聊
    datas = { touserids: conventioners };
  }
  if (openType == "1") {
    // 群聊
    datas = { togroupids: conventioners };
  }
  if (openType == "2") {
    // 创建新的群聊
    datas = { create_group_members: conventioners };
    if (groupName && groupName !== "") {
      datas = { ...datas, create_group_name: groupName };
    }
  }
  callApi("/api/ec/dev/share/openConversation", "POST", {
    data: JSON.stringify(datas)
  }).then(result => {
    if (result.status && result.data.errcode === 0) {
      typeof successCallBack === "function" && successCallBack(result);
    } else {
      message.error(
        (result.data && result.data.errmsg) ||
          getLable("386484", "对话创建失败！")
      );
      typeof errorCallBack === "function" && errorCallBack();
    }
  });
};



// WEBPACK FOOTER //
// ./ecology9/wea-popover-hrm/util/index.js